// Copyright(c) 2021 JCA Electronics, Winnipeg, MB.All rights reserved.

/**
 * Application Parameters that are passed along with a single path mission
 * as a dictionary of application specific data.
 * @link https://bitbucket.jcaelectronics.ca/projects/ER/repos/exxact_cloud_interface/browse?at=refs%2Fheads%2Fdevelop
 * @example
 *  implement_type - string
 *  vine_width - number in meters
 *  volume - number in L/Hectare
 *  spray_product - string
 */
export enum Parameters {
  implementType = 'implement_type',
  vineWidth = 'vine_width', // meters
  volume = 'volume', // L per Hectare
  sprayProduct = 'spray_product',
  engineSpeed = 'engine_speed'
}

export enum SprayerProductTypes {
  Product1 = 'Product1' // place holder - until exxact decide what products to add
}
export enum ImplementKeys {
  sprayer = 'sprayer',
  disc = 'disc',
  blade = 'blade',
  mower = 'mower',
  plough = 'plough',
  // Will be broken out into disc, blade, mower once those implements are defined, keeping
  // generic `weeder` for now so mission creation and deploy still works for current weeder implement
  weeder = 'weeder',
  // not an actual implement, used to distinguish between spraying/tillage missions
  tillage = 'tillage',
  none = 'none'
}
